import { useAuth0 } from '@auth0/auth0-react'
import { useSearchParams } from 'react-router-dom'
import { ViewLayout } from '../components/layouts/ViewLayout'
import { ComponentLayout } from '../components/layouts/ComponentLayout'
import { useEffect } from 'react'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { startSilentSsoLogin } from '../utils/authSource'

// Users from the Benifex tile already have an Auth0 session, and only a silent login without a connection reuses it.
// Without a session, AuthErrorGate falls back to a normal login.
export const SsoLogin = () => {
  const { loginWithRedirect } = useAuth0()
  const [searchParams] = useSearchParams()
  const returnTo = searchParams.get('returnTo') || '/portal'

  useEffect(() => {
    startSilentSsoLogin(returnTo)
    loginWithRedirect({
      authorizationParams: { prompt: 'none', connection: undefined },
      appState: {
        returnTo,
      },
    })
  }, [loginWithRedirect, returnTo])

  return (
    <ViewLayout>
      <ComponentLayout>
        <LoadingSpinner />
      </ComponentLayout>
    </ViewLayout>
  )
}
